var React = require('react');

function CrossBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m221.44 207.5 42.56-42.5a11.44 11.44 0 0 0 -16.18-16.18l-42.54 42.54-42.54-42.54a11.44 11.44 0 0 0 -16.2 16.18l42.54 42.54-42.54 42.46a11.44 11.44 0 0 0 16.18 16.18l42.54-42.54 42.54 42.54a11.44 11.44 0 0 0 16.2-16.18z","fill":"#2a6fab"}));
}

CrossBlue.defaultProps = {"viewBox":"0 0 410 405"};

module.exports = CrossBlue;

CrossBlue.default = CrossBlue;
